import React, { Component } from 'react';
import { get } from 'lodash';
import { LoadingSpinner } from '../LoadingSpinner';
import InternetBankingContentStore from '../../stores/InternetBankingContentStore';
import SessionStore from '../../stores/SessionStore';
import AppStore from '../../stores/AppStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import envConfig from '../../../static/config';

let scriptLoaded = false;

class ManagePersonalDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: scriptLoaded,
    };

    this.importMap = {};
    this.addScript();
    this.notifyMPD = this.notifyMPD.bind(this);
    InternetBankingActions.clearWebTask(); // Required to allow use of back buton with least impact throughout iB
  }

  addScript() {
    if (!scriptLoaded) {
      this.importMap = {
        imports: {
          'single-spa': `${envConfig.managePersonalDetails.baseUrl}/single-spa.js`,
          react: `${envConfig.managePersonalDetails.baseUrl}/react.js`,
          'react-dom': `${envConfig.managePersonalDetails.baseUrl}/react-dom.js`,
          'root-config': `${envConfig.managePersonalDetails.baseUrl}/root-config.js`,
          '@VM/manage-personal-details': `${envConfig.managePersonalDetails.baseUrl}/VM-manage-personal-details.js`,
        },
      };

      const im = document.createElement('script');
      im.type = 'systemjs-importmap';
      im.textContent = JSON.stringify(this.importMap, null, 3);
      document.body.appendChild(im);
      window.System.prepareImport(true);
      scriptLoaded = true;
    }
  }

  notifyMPD(event) {
    if (event.data === 'MPD READY') {
      this.setState({
        loaded: true,
      });
      window.postMessage(
        {
          accessToken: this.props.session.accessToken,
          appTitle: InternetBankingContentStore.get('documentTitle'),
          bankId: SessionStore.getSessionBankID(),
          customer: SessionStore.getCurrentUser(),
          userTrackingId: AppStore.getUserTrackingID(),
          enabledFeatures: get(
            envConfig,
            'managePersonalDetails.enabledFeatures'
          ),
        },
        window.location.origin
      );
      return;
    }

    const route = get(event, 'data.route');
    if (route) {
      InternetBankingActions.navigateToWebTask(route);
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.notifyMPD, false);
    window.System.import('root-config').catch((e) => {
      InternetBankingActions.navigateToWebTask('WEB-ERROR');
    });
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.notifyMPD);
  }

  render() {
    if (this.state.loaded) {
      // DOM EL added in index.html
      return null;
    }

    return <LoadingSpinner />;
  }
}

export default ManagePersonalDetails;
